import { Button, Container, FormControl } from "react-bootstrap";
import { useState } from "react";
import { registerAsync } from "./registrationSlice";
import { useAppSelector } from "../../app/hooks";
import { userManager } from "../auth/authService";
import { useDispatch } from "react-redux";

export default function Register() {
  var [username, setUsername] = useState("");
  var [email, setEmail] = useState("");
  var [password, setPassword] = useState("");
  var [passwordConfirmation, setPasswordConfirmation] = useState("");

  var registrationStatus = useAppSelector((state) => state.registration.status);

  const dispatch = useDispatch();

  const register = () => {
    dispatch(
      registerAsync({
        username,
        email,
        password,
      })
    );
  };

  if (registrationStatus === "succeeded") userManager.signinRedirect();

  return (
    <Container>
      <h2>Register</h2>

      <FormControl
        placeholder="Username"
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <FormControl
        placeholder="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <FormControl
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <FormControl
        placeholder="Confirm Password"
        type="password"
        value={passwordConfirmation}
        onChange={(e) => setPasswordConfirmation(e.target.value)}
      />

      <Button onClick={() => register()}>Register</Button>
    </Container>
  );
}
